import { CircleCheckIcon } from 'lucide-react';

export const NavTask = CircleCheckIcon;
